/*
  Laurent: Einblend-Leiste "Privat · Händler" (Spec 60; seit 29.10.2026
  statt Newsletter, Marcel).

  Einmal, nach 60 Sekunden oder halber Seitenlaenge — je nachdem, was zuerst
  eintritt. Wer schliesst oder einen der Knoepfe drueckt, sieht sie 90 Tage
  nicht wieder.

  Beim Klick auf "Privat" oder "Händler" haengt das Skript ?zurueck=<Pfad>
  an, damit "Zurück" auf der Kontoseite genau hierher fuehrt. Nur der Pfad
  samt Abfrage dieser Seite, keine Kundendaten.

  Neuer Speicherschluessel: wer die Newsletter-Leiste geschlossen hatte, sieht
  die neue Leiste trotzdem einmal.

  Kein Ausgangsversuch-Ausloeser, kein Sperren des Scrollens, keine zweite
  Frage nach dem Schliessen (Spec 60).

  Die Ruhefrist steht in localStorage als Zeitpunkt, ab dem sie wieder
  erscheinen darf. Ist localStorage nicht verfuegbar (privates Fenster,
  gesperrte Speicherung), erscheint die Leiste in dieser Sitzung einmal und
  danach nicht wieder — schlimmer als die Frist, aber nie oefter.
*/

(function () {
  var SCHLUESSEL = 'lh-konto-leiste-ruhe';
  var RUHE_TAGE = 90;
  var WARTEZEIT = 60000;

  var leiste = document.querySelector('[data-lh-leiste]');
  if (!leiste) return;

  function jetzt() {
    return new Date().getTime();
  }

  function darfErscheinen() {
    try {
      var bis = window.localStorage.getItem(SCHLUESSEL);
      return !bis || jetzt() > parseInt(bis, 10);
    } catch (e) {
      return true;
    }
  }

  function ruhigStellen() {
    try {
      window.localStorage.setItem(SCHLUESSEL, jetzt() + RUHE_TAGE * 86400000);
    } catch (e) {
      /* Ohne Speicher bleibt es bei dieser Sitzung. */
    }
  }

  if (!darfErscheinen()) return;

  var gezeigt = false;

  function zeigen() {
    if (gezeigt) return;
    gezeigt = true;
    leiste.hidden = false;
    /* Kurz warten, damit der Uebergang laeuft: die Leiste muss erst im
       Layout stehen, bevor die Klasse sie hereinschiebt.
       requestAnimationFrame waere naheliegend, laeuft aber in einem Tab im
       Hintergrund nicht — die Leiste stuende dann sichtbar, aber noch
       ausserhalb des Bildes. */
    window.setTimeout(function () {
      leiste.classList.add('lh-leiste--da');
    }, 20);
    aufraeumen();
  }

  function schliessen() {
    ruhigStellen();
    leiste.classList.remove('lh-leiste--da');
    leiste.hidden = true;
  }

  function beimScrollen() {
    var hoehe = document.documentElement.scrollHeight - window.innerHeight;
    if (hoehe <= 0) return;
    if (window.scrollY / hoehe >= 0.5) zeigen();
  }

  var uhr = window.setTimeout(zeigen, WARTEZEIT);

  function aufraeumen() {
    window.clearTimeout(uhr);
    window.removeEventListener('scroll', beimScrollen);
  }

  window.addEventListener('scroll', beimScrollen, { passive: true });

  var zu = leiste.querySelector('[data-lh-leiste-zu]');
  if (zu) zu.addEventListener('click', schliessen);

  /* Wer einen Knopf drueckt, hat die Frage beantwortet. Dazu die Adresse
     dieser Seite mitgeben, fuer "Zurück" auf der Kontoseite. */
  Array.prototype.forEach.call(leiste.querySelectorAll('[data-lh-leiste-ziel]'), function (a) {
    a.addEventListener('click', function () {
      ruhigStellen();
      try {
        var ziel = new URL(a.getAttribute('href'), window.location.href);
        ziel.searchParams.set('zurueck', window.location.pathname + window.location.search);
        a.setAttribute('href', ziel.pathname + ziel.search + ziel.hash);
      } catch (e) {
        /* Ohne URL-Unterstuetzung bleibt der Link, wie er ist. */
      }
    });
  });
})();
